import { Directive, ElementRef, inject, Input, SimpleChanges } from '@angular/core';
import {
    AsyncValidator, AsyncValidatorFn,
    ControlContainer,
    ControlValueAccessor,
    FormControlName,
    NG_ASYNC_VALIDATORS,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR, Validator, ValidatorFn,
} from '@angular/forms';

@Directive({
    standalone: true,
    selector: '[uiFormItem]',
})
export class UiFormItemDirective extends FormControlName {

    @Input({ required: true }) pageCode: string;
    @Input({ alias: 'uiFormItem', required: true }) controlName: string;

    //override required input
    @Input({ alias:'formControlName', required: false }) private formControlName: string;

    elementRef: ElementRef;

    constructor(elementRef: ElementRef) {
        super(
            inject(ControlContainer, { optional: true, host: true, skipSelf: true }),
            inject(NG_VALIDATORS, { optional: true, self: true }) as (Validator | ValidatorFn)[],
            inject(NG_ASYNC_VALIDATORS, { optional: true, self: true }) as (AsyncValidator | AsyncValidatorFn)[],
            inject(NG_VALUE_ACCESSOR, { optional: true, self: true }) as ControlValueAccessor[],
            null);

        this.elementRef = elementRef;
    }

    ngOnChanges(changes: SimpleChanges) {
        this.name = this.controlName;
        super.ngOnChanges(changes);
    }

    ngOnInit(): void {
        this.elementRef.nativeElement.id = this.pageCode + '_' + this.name;
        this.elementRef.nativeElement.name = this.name.toString();
    }

}
